import React from 'react'
import { observer } from 'mobx-react'
import Badge from '../../../UniformComponents/Badge'
import { LogicOption } from './LogicOption'
import { IgnoreNote } from './IgnoreNote'

const Gate = observer(({
    store, gate, scope, label, sublabel, matchAnyOptions, matchAnyCallback, ignoreText,
}) => {
    const error = store.gateError(gate)
    return (
        <div className="ff-gate is-structural">
            <div className="ff-gate__rail" />
            <div className="ff-gate__body">
                <div className="ff-gate__header">
                    <div>
                        <div className="ff-gate__label">{label}</div>
                        <div className="ff-gate__sublabel">{sublabel}</div>
                    </div>
                    <div>
                        <Badge
                            label={store.getLogicLabel(gate.logic, scope)}
                            isRounded
                            cssClass="ff-pill"
                            type={gate.logic === 'OR' ? 'success' : gate.logic === 'ignore' ? 'grey' : 'secondary'}
                        />
                    </div>
                    <div className="ff-gate__summary">{store.flag.getSummary(scope, matchAnyOptions)}</div>
                    <div className="ff-gate__actions">
                        {error && (
                            <span className="ff-pill ff-pill--danger">
                                <i className="fal fa-triangle-exclamation" />
                                {error}
                            </span>
                        )}
                    </div>
                </div>
                <div className="ff-gate__editor">
                    <div className="ff-gate__section">
                        <div className="ff-eyebrow">Condition test</div>
                        <LogicOption
                            store={store}
                            scope={scope}
                            onClick={(logic) => {
                                if (logic === 'ignore') {
                                    gate.options = []
                                }
                                gate.logic = logic
                            }}
                        />
                    </div>
                    <IgnoreNote
                        mode={gate.logic}
                        text={ignoreText}
                    />
                    {gate.logic === 'OR' && (
                        <div className="ff-gate__section">
                            <div className="ff-eyebrow">Addons that pass</div>
                            <div className="ff-chips">
                                {matchAnyOptions.map(([addon, title]) => (
                                    <div
                                        className={`ff-chip ${gate.options.includes(addon) ? 'is-selected' : ''}`}
                                        onClick={() => matchAnyCallback(addon)}
                                    >
                                        {title}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </div>
    )
})

export default Gate
